{
  "auth": {
    "agree": "I agree to",
    "createAccount": "Create account",
    "createNewAccount": "Create New Account",
    "email": "Email",
    "login": "Login",
    "password": "Password",
    "recover_password": "Recover password",
    "sign_up": "Sign Up",
    "keep_logged_in": "Keep me logged in",
    "termsOfUse": "Terms of Use.",
    "reset_password": "Reset password"
  },
  "404": {
    "title": "This page’s gone fishing.",
    "text": "If you feel that it’s not right, please send us a message at ",
    "back_button": "Back to dashboard"
  },
  "typography": {
    "primary": "Primary text styles",
    "secondary": "Secondary text styles"
  },
  "dashboard": {
    "versions": "Versions",
    "setupRemoteConnections": "Setup Remote Connections",
    "currentVisitors": "Current Visitors",
    "navigationLayout": "navigation layout",
    "topBarButton": "Top Bar",
    "sideBarButton": "Side Bar"
  },
  "language": {
    "brazilian_portuguese": "Português",
    "english": "English",
    "spanish": "Spanish",
    "simplified_chinese": "Simplified Chinese",
    "persian": "Persian"
  },
  "menu": {
    "access-control": "Access Control",
    "auth": "Auth",
    "buttons": "Buttons",
    "timelines": "Timelines",
    "dashboard": "Dashboard",
    "billing": "Billing",
    "complaints": "Complaints",
    "login": "Login",
    "statistics": "Statistics",
    "roles": "Roles",
    "order": "order",
    "orders": "Orders",
    "unsettled-orders": "Unsettle Order",
    "refund-orders": "Refund Orders",
    "reviews": "Reviews",
    "service": "service",
    "services": "Services",
    "slot-counts": "Slot Count",
    "locations": "Locations",
    "partner": "Partner",
    "partners": "Partners",
    "resources": "Resources",
    "partner-wallet": "Partner Wallet",
    "partner-payments": "Partner Payments",
    "partner-tutorials": "Partner Tutorials",
    "in-house-salary": "In-House Salary",
    "in-house-leaves": "In-House Leaves",
    "in-house-notice": "In-House Notice",
    "sp-join-requests": "SP Join Requests",
    "sp-sos-alerts": "SP Sos Alerts",
    "sp-locations-tracking": "SP Locations Tracking",
    "marketing": "Marketing",
    "push-notification": "Push Notification",
    "future-notification": "Future Notification",
    "schedule-notification": "Schedule Notification",
    "feed": "Feed",
    "promo-codes": "Promo Codes",
    "hot-deals": "Hot Deals",
    "card-bins": "Card BINs",
    "banners": "Banners",
    "payment-method": "Payment Method",
    "advance-payment-method": "Advance Payment Schedule",
    "reports": "Reports",
    "area-wise-reports": "Area Wise Reports",
    "line-item-revenue": "Line Item Revenue",
    "sp-wise-order-count": "Sp Wise Order Count",
    "old-reports": "Old Reports",
    "cs-reports": "CS Reports",
    "sp-route": "SP Route",
    "otps": "OTPs",
    "products": "Products",
    "all-products": "All Products",
    "product-request": "Product Request",
    "order-settings": "Order Settings",
    "min-order-amount": "Min Order Amount",
    "min-order-time": "Min Order Time",
    "min-payment-time": "Min Payment Time",
    "reward-faq": "Reward FAQ",
    "reward-status": "Reward Status",
    "redeem-settings": "Redeem settings",
    "reward-user": "Reward User",
    "categories": "Categories",
    "sub-categories": "Sub Categories",
    "line-items": "Line Items",
    "preferences": "Account preferences",
    "payments": "Payments",
    "settings": "Application settings",
    "pricing-plans": "Pricing plans",
    "payment-methods": "Payment methods",
    "signup": "Signup",
    "recover-password": "Recover password",
    "recover-password-email": "Recover password email",
    "404": "404",
    "faqs": "FAQs",
    "users": "Users",
    "projects": "Projects",
    "ticker": "Ticker",
    "mou-partners": "Mou Partners",
    "promotions": "Promotions",
    "future-of-beauty": "Future of Beauty",
    "payment-channel": "Payment Channel",
    "content-management": "Content Management",
    "reward-point": "Reward Point"
  },
  "messages": {
    "all": "See all messages",
    "new": "New messages from {name}",
    "mark_as_read": "Mark As Read"
  },
  "navbar": {
    "messageUs": "Web development inquiries:",
    "repository": "GitHub Repo"
  },
  "notifications": {
    "all": "See all notifications",
    "less": "See less notifications",
    "mark_as_read": "Mark as read",
    "sentMessage": "sent you a message",
    "uploadedZip": "uploaded a new Zip file with {type}",
    "startedTopic": "started a new topic"
  },
  "user": {
    "language": "Change language",
    "logout": "Logout",
    "profile": "Profile",
    "settings": "Settings",
    "billing": "Billing",
    "faq": "FAQ",
    "helpAndSupport": "Help & support",
    "projects": "Projects",
    "account": "Account",
    "explore": "Explore"
  },
  "treeView": {
    "basic": "Basic",
    "icons": "Icons",
    "selectable": "Selectable",
    "editable": "Editable",
    "advanced": "Advanced"
  },
  "chat": {
    "title": "Chat",
    "sendButton": "Send"
  },
  "spacingPlayground": {
    "value": "Value",
    "margin": "Margin",
    "padding": "Padding"
  },
  "spacing": {
    "title": "Spacing"
  },
  "cards": {
    "cards": "Cards",
    "fixed": "Fixed",
    "floating": "Floating",
    "contentText": "The unique stripes of zebras make them one of the animals most familiar to people.",
    "contentTextLong": "The unique stripes of zebras make them one of the animals most familiar to people. They occur in a variety of habitats, such as grasslands, savannas, woodlands, thorny scrublands, mountains, and coastal hills. Various anthropogenic factors have had a severe impact on zebra populations, in particular hunting for skins and habitat destruction. Grévy's zebra and the mountain zebra are endangered. While plains zebras are much more plentiful, one subspecies, the quagga.",
    "rowHeight": "Row height",
    "title": {
      "default": "Default",
      "withControls": "With controls",
      "customHeader": "Custom header",
      "withoutHeader": "Without header",
      "withImage": "With Image",
      "withTitleOnImage": "With title on image",
      "withCustomTitleOnImage": "With custom title on image",
      "withStripe": "With stripe",
      "withBackground": "With background"
    },
    "button": {
      "main": "Main",
      "cancel": "Cancel",
      "showMore": "Show More",
      "readMore": "Show More"
    },
    "link": {
      "edit": "Edit",
      "setAsDefault": "Set as default",
      "delete": "Delete",
      "traveling": "Traveling",
      "france": "France",
      "review": "Review",
      "feedback": "Leave feedback",
      "readFull": "Read full article",
      "secondaryAction": "Secondary action",
      "action1": "Action 1",
      "action2": "Action 2"
    }
  },
  "colors": {
    "themeColors": "Theme Colors",
    "extraColors": "Extra Colors",
    "gradients": {
      "basic": {
        "title": "Button Gradients"
      },
      "hovered": {
        "title": "Hovered Button Gradients",
        "text": "Lighten 15% applied to an original style (gradient or flat color) for hover state."
      },
      "pressed": {
        "title": "Pressed Button Gradients",
        "text": "Darken 15% applied to an original style (gradient or flat color) for pressed state."
      }
    }
  },
  "tabs": {
    "alignment": "Tabs alignment",
    "overflow": "Tabs overflow",
    "hidden": "Tabs with hidden slider",
    "grow": "Tabs grow"
  },
  "helpAndSupport": "Help & support",
  "aboutVuesticAdmin": "About Vuestic Admin",
  "search": {
    "placeholder": "Search..."
  },
  "buttonSelect": {
    "dark": "Dark",
    "light": "Light"
  },

  "allMonths": [
    { "value": 1, "text": "January" },
    { "value": 2, "text": "February" },
    { "value": 3, "text": "March" },
    { "value": 4, "text": "April" },
    { "value": 5, "text": "May" },
    { "value": 6, "text": "June" },
    { "value": 7, "text": "July" },
    { "value": 8, "text": "August" },
    { "value": 9, "text": "September" },
    { "value": 10, "text": "October" },
    { "value": 11, "text": "November" },
    { "value": 12, "text": "December" }
  ],

  "years": [
    { "value": 2018, "text": "2018" },
    { "value": 2019, "text": "2019" },
    { "value": 2020, "text": "2020" },
    { "value": 2021, "text": "2021" },
    { "value": 2022, "text": "2022" },
    { "value": 2023, "text": "2023" },
    { "value": 2024, "text": "2024" },
    { "value": 2025, "text": "2025" }
  ]
}
